/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import ReactGA from "react-ga4";
import { Link } from "react-router-dom";

import { getSkus } from "models/inventory/controllers/sku.controller";

import { SOCIAL_MEDIA } from "constants/media.constants";
import { ScalableImage, Typography, useDevice } from "design_system/src";
import { ReactComponent as Facebook } from "design_system/src/static/icons/Facebook 2.svg";
import { ReactComponent as Instagram } from "design_system/src/static/icons/instagram.svg";
import { ReactComponent as LinkedIn } from "design_system/src/static/icons/linkedin.svg";
import { ReactComponent as Mail } from "design_system/src/static/icons/mail.svg";
import { ReactComponent as TikTok } from "design_system/src/static/icons/tiktok.svg";
import { ReactComponent as WhatsApp } from "design_system/src/static/icons/whatsapp.svg";
import { ReactComponent as YouTube } from "design_system/src/static/icons/youtube.svg";
import { firstLetterUpper } from "helpers/setFirstLetterUpper";

interface SocialMediaLink {
  name: string;
  link: string;
  icon: React.ReactElement;
}

export const Footer = () => {
  const { isMobile } = useDevice();
  const catalogPathName = "/catalogo";

  const [homeBrands, setHomeBrands] = useState<string[]>([]);

  useEffect(() => {
    getSkus({ limit: 1, page: 1 })
      .then((result) => setHomeBrands(result.filters.brands))
      .catch(() => setHomeBrands([]));
  }, []);

  const handleEventOzocio = () => {
    ReactGA.event("CTA_ozocio_footer", {
      category: "Ozocio",
      label: "click ozocio from footer",
    });
  };

  const handleNet = (social: string) => {
    switch (social) {
      case "facebook":
        window.open(SOCIAL_MEDIA.MX.facebook, "_blank");
        break;
      case "twitter":
        window.open(SOCIAL_MEDIA.MX.twitter, "_blank");
        break;
      case "instagram":
        window.open(SOCIAL_MEDIA.MX.instagram, "_blank");
        break;
      case "tiktok":
        window.open(SOCIAL_MEDIA.MX.tiktok, "_blank");
        break;

      default:
        break;
    }
  };

  const links: SocialMediaLink[] = [
    {
      name: "facebook",
      link: SOCIAL_MEDIA.MX.facebook,
      icon: <Facebook className="dim_20_px text_neutral_0" />,
    },
    {
      name: "instagram",
      link: SOCIAL_MEDIA.MX.instagram,
      icon: <Instagram className="dim_20_px text_neutral_0" />,
    },
    {
      name: "tiktok",
      link: SOCIAL_MEDIA.MX.tiktok,
      icon: <TikTok className="dim_20_px text_neutral_0" />,
    },
    {
      name: "linkedIn",
      link: SOCIAL_MEDIA.MX.linkedin,
      icon: <LinkedIn className="dim_20_px text_neutral_0" />,
    },
    {
      name: "youTube",
      link: SOCIAL_MEDIA.MX.youtube,
      icon: <YouTube className="dim_20_px text_neutral_0" />,
    },
  ];

  return (
    <>
      <div className="bg_neutral_900">
        <div className="dso_container">
          <div className="m_t_xl m_b_xxl">
            <div className="display_flex flex_align_center flex_gap_sm h_40_px">
              <div className="p_r_lg h_100_per w_50_per_mobile">
                <ScalableImage
                  src="https://ik.imagekit.io/ozon/Compartidos/Logos/logo_ozon_blanco"
                  desktopWidth={10}
                  mobileWidth={5}
                  className="img_contain"
                  alt="Logo Ozon – Plataforma de financiamiento de motos nuevas y seminuevas en CDMX"
                />
              </div>
              <Typography scale="small" weight="600" className="pr_lg">
                by
              </Typography>
              <Link to="https://www.payjoy.com/mx" className="custom_a h_xl">
                <ScalableImage
                  src="https://ik.imagekit.io/ozon/Homepage/Logos/logo_blanco_payjoy.png"
                  alt="PayJoy - Financiamiento"
                  className="h_xl"
                  desktopWidth={5}
                  mobileWidth={5}
                />
              </Link>
            </div>
          </div>
          <div className="m_b_xl">
            <div className="display_flex flex_col flex_row_desktop flex_gap_md">
              <div className="w_100_per w_25_per_desktop">
                <Typography scale="medium" weight="600" className="m_b_xl">
                  Canales de soporte
                </Typography>

                <address>
                  <a
                    href="mailto:soportemx@ozon.mobi"
                    target="_blank"
                    rel="noreferrer"
                    style={{ textDecoration: "none" }}
                  >
                    <div className="display_flex flex_gap_sm m_b_md">
                      <div className="bg_primary_300 dim_30_px display_flex flex_center br_xxxl">
                        <Mail className="dim_20_px text_neutral_0" />
                      </div>
                      <Typography
                        scale="small"
                        weight="400"
                        className="cursor_pointer display_flex flex_row flex_align_center text_neutral_0"
                        style={{ wordWrap: "break-word", fontStyle: "normal" }}
                      >
                        soportemx@ozon.mobi
                      </Typography>
                    </div>
                  </a>
                  {process.env.REACT_APP_WHATSAPP && (
                    <a
                      href={`https://api.whatsapp.com/send?phone=${process.env.REACT_APP_WHATSAPP}&text=Hola%20me%20interesa%20saber%20sobre%20Ozon%20`}
                      target="_blank"
                      rel="noreferrer"
                      style={{ textDecoration: "none" }}
                    >
                      <div className="display_flex flex_gap_sm m_b_md">
                        <div
                          className="dim_30_px display_flex flex_center br_xxxl"
                          style={{ backgroundColor: "#5CE529" }}
                        >
                          <WhatsApp className="dim_20_px text_neutral_0" />
                        </div>
                        <Typography
                          scale="small"
                          weight="400"
                          className="cursor_pointer display_flex flex_row flex_align_center text_neutral_0"
                          style={{
                            wordWrap: "break-word",
                            fontStyle: "normal",
                          }}
                        >
                          +52{" "}
                          {process.env.REACT_APP_WHATSAPP.replace(
                            /^52\d?/,
                            ""
                          ).replace(/(\d{2})(\d{4})(\d{4})/, "($1) $2-$3")}
                        </Typography>
                      </div>
                    </a>
                  )}
                </address>
              </div>
              <div className="w_100_per w_30_per_desktop">
                <Typography scale="medium" weight="600" className="m_b_xl">
                  Sobre Ozon
                </Typography>

                <div
                  className="display_flex flex_wrap_desktop flex_col"
                  style={{ maxHeight: isMobile ? "unset" : "200px" }}
                >
                  <Link to="/catalogo" className="custom_a">
                    <Typography scale="medium" weight="400" className="m_b_lg">
                      Compra tu moto
                    </Typography>
                  </Link>
                  <Link to="/mi-cuenta" className="custom_a">
                    <Typography scale="medium" weight="400" className="m_b_lg">
                      Mi Cuenta
                    </Typography>
                  </Link>
                  {/* <Link
                    to="https://docs.google.com/forms/d/e/1FAIpQLSfQ-8vLdEroKjnMBzf3WY9oxsy33fUkx1GMe4ef-wdEJqZGiA/viewform"
                    target="_blank"
                    rel="noreferrer"
                    className="custom_a"
                  >
                    <Typography scale="medium" weight="400" className="m_b_lg">
                      Trabaja con nosotros
                    </Typography>
                  </Link> */}
                  <Link to="/faqs" className="custom_a">
                    <Typography scale="medium" weight="400" className="m_b_lg">
                      Ayuda
                    </Typography>
                  </Link>
                </div>
              </div>
              <div className="w_100_per w_30_per_desktop">
                <Typography scale="medium" weight="600" className="m_b_xl">
                  Marcas
                </Typography>

                <div
                  className="display_flex flex_wrap_desktop flex_col"
                  style={{ maxHeight: isMobile ? "unset" : "200px" }}
                >
                  {homeBrands.map((brand) => (
                    <Link
                      key={brand}
                      to={`${catalogPathName}?brand=${brand}`}
                      className="custom_a"
                    >
                      <Typography
                        scale="medium"
                        weight="400"
                        className="cursor_pointer m_b_lg"
                        onClick={handleEventOzocio}
                      >
                        {firstLetterUpper(brand)}
                      </Typography>
                    </Link>
                  ))}
                </div>
              </div>
              <div className="w_100_per w_15_per_desktop">
                <Typography scale="medium" weight="600" className="m_b_xl">
                  Siguenos en:
                </Typography>

                <div className="display_flex flex_wrap flex_gap_sm">
                  {links.map(({ name, link, icon }) => {
                    return (
                      // eslint-disable-next-line react/jsx-no-target-blank
                      <a
                        href={link}
                        target="_blank"
                        key={`SocialMedia-${name}`}
                        aria-label={`SocialMedia-${name}`}
                      >
                        <div className="bg_primary_200 dim_30_px display_flex flex_center br_xxxl">
                          {icon}
                        </div>
                      </a>
                    );
                  })}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <footer className="bg_neutral_1000">
        <div className="dso_container w_100_per display_flex flex_col flex_row_desktop flex_gap_md_desktop">
          <div className="w_100_per w_25_per_desktop p_y_md">
            <Link to="/terminos-y-condiciones" className="custom_a">
              <Typography scale="xsmall" weight="600">
                Términos y Condiciones
              </Typography>
            </Link>
          </div>
          <div className="w_100_per w_25_per_desktop p_y_md">
            <Link to="/aviso-de-privacidad" className="custom_a">
              <Typography scale="xsmall" weight="600">
                Aviso de Privacidad
              </Typography>
            </Link>
          </div>
          <div className="w_100_per w_50_per_desktop p_y_md display_flex flex_center">
            <Typography
              scale="xsmall"
              weight="600"
              className="text_neutral_600"
            >
              OZON® Todos los derechos reservados. {new Date().getFullYear()}
            </Typography>
          </div>
        </div>
      </footer>
    </>
  );
};
